import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const mensajeriaService = {
  InsertOrUpdate,
  GetAll,
  Delete,
  getmensajeriaById,
}

async function InsertOrUpdate(body) {
  return await ApiBudgety.post('Mensajeria/InsertOrUpdate', body, {
    headers: {
      ACCION: MenusSistema.configuracion_mensajeria.accesos.activa_desactiva_mensajeria,
      MENU: MenusSistema.configuracion_mensajeria.id,
    },
  })
}

async function GetAll(body) {
  return await ApiBudgety.post('Mensajeria/GetAll', body, {
    headers: {
      ACCION: MenusSistema.configuracion_mensajeria.accesos.listar_usuarios_para_mensajeria,
      MENU: MenusSistema.configuracion_mensajeria.id,
    },
  })
}

async function Delete(id) {
  return await ApiBudgety.post('Mensajeria/Delete/' + id, {
    headers: {
      ACCION: MenusSistema.configuracion_mensajeria.accesos.activa_desactiva_mensajeria,
      MENU: MenusSistema.configuracion_mensajeria.id,
    },
  })
}

async function getmensajeriaById(id) {
  return await ApiBudgety.get('Mensajeria/FindById/' + id, {
    headers: {
      ACCION: MenusSistema.configuracion_mensajeria.accesos.listar_usuarios_para_mensajeria,
      MENU: MenusSistema.configuracion_mensajeria.id,
    },
  })
}
